import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

export const useRemoveFromMembership = requestBuilder.mutation<
    GeneralResponse,
    undefined,
    { id: string; userId: string }
>({
    endpoint: ({ id, userId }) =>
        `/api/admin/memberships/${id}/members/${userId}`,
    method: 'DELETE',
});
